import { LoadScript } from "@react-google-maps/api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import moment from "moment";
import { useState } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import appConfig from "./appConfig";
import AppLoading from "./components/shared/Loaders/HomeLoading/AppLoading";
import { ConfigProvider } from "./context/ConfigContext";
import { useAppInit } from "./hooks/useAppInit";
import AppRoutes from "./navigation";
import AxiosInterceptor from "./services/useAxiosInterceptors";
import configureStore from "./store/store";
import "./style.scss";
import CartCleanupWrapper from "./wrapper/CartCleanupWrapper";

// Component that uses both Redux and Config context
function AppInitializer() {
  const [isInitialized, setIsInitialized] = useState(false);

  useAppInit();

  // Set initialization to true after hook runs
  if (!isInitialized) {
    setIsInitialized(true);
  }

  if (!isInitialized) {
    return <AppLoading />;
  }

  return (
    <div className="container">
      <CartCleanupWrapper />
      <AxiosInterceptor />
      <AppRoutes />
    </div>
  );
}

function App() {
  moment.locale("fr");
  const { store, persistor } = configureStore();

  return (
    <Provider store={store}>
      <PersistGate loading={<AppLoading />} persistor={persistor}>
        <GoogleOAuthProvider clientId={appConfig.GOOGLE_OAUTH_CLIENT_ID}>
          <LoadScript
            libraries={["places"]}
            id={"TheOneAndOnlyGmaps"}
            language={"fr"}
            region={"FR"}
            googleMapsApiKey={appConfig.GOOGLE_MAPS_API_KEY}
            onLoad={() => console.log("onloaddd")}
            loadingElement={<AppLoading />}
          >
            <ConfigProvider>
              <AppInitializer />
            </ConfigProvider>
          </LoadScript>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;